import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Markdown from "src/components/Markdown";

const SubTitleSection = ({ subTitle, text, as: Tag = 'h2', dark = true, className, borderColor, id, variant = 'default', subtitleColor }) => {
  const classes = `subtitle-section ${variant === 'compact' ? 'compact' : ''} ${className || ''}`.trim();

  return (
    <Section dark={dark} className={classes} borderColor={borderColor} id={id ? id : ''} subtitleColor={subtitleColor}>
      <Tag>{subTitle}</Tag>
      <Markdown>{text}</Markdown>
    </Section>
  );
};

SubTitleSection.propTypes = {
  subTitle: PropTypes.node.isRequired,
  borderColor: PropTypes.string,
};

const Section = styled.div`
  width: 100%;
  padding: 20px 0;

  h1, h2 {
    color: ${(props) => props.subtitleColor || (props.dark ? "var(--lightgrey)" : "var(--black)")};
    margin: 0;
    font-weight: 700;
    font-size: 2rem;
    position: relative;
    word-break: keep-all;
    &:before {
      border-bottom: 2px solid var(--lightblack);
      content: '';
      display: block;
      width: 100%;
      position: absolute;
      bottom: 0;
    }
    &:after {
      content: '';
      display: block;
      width: 100%;
      max-width: 160px;
      border-bottom: 2px solid ${(props) => (props.borderColor ? props.borderColor : "var(--red)")};
      position: relative;
    }
  }

  h3, h4 {
    color: ${(props) => props.subtitleColor || (props.dark ? "var(--lightgrey)" : "var(--black)")};
    border-left: solid 3px var(--red);
    padding-left: 0.7rem;
    font-size: 1.5rem;
    word-break: keep-all;
  }

  h4 {
    font-size: 1.3rem;
  }

  p, li {
    margin: 1rem 0;
    color: ${(props) => (props.dark ? "var(--lightgrey)" : "var(--black)")};
  }

  /* Compact variant styles */
  &.compact {
    h1, h2 {
      margin-bottom: 5px;
    }

    h3, h4 {
      border-left: none;
      padding-left: 0;
      margin-bottom: 5px;
    }

    h4 {
      margin-top: 5px;
    }

    p, li {
      margin-top: 0 !important;
    }
    li {
      margin-bottom: 0;
    }
  }

  /* Text center with no borders */
  &.text-center {
    h1, h2, h3, h4 {
      text-align: center;
    }

    h1, h2 {
      &:before, &:after {
        display: none;
      }
    }

    h3, h4 {
      border-left: none;
      padding-left: 0;
    }
  }

  @media screen and (max-width: 991px) {
    h3 {
      font-size: 1.2rem;
    }
    h4 {
      font-size: 1.1rem;
    }
    p {
      font-size: 0.9rem;
    }
  }
`;

export default SubTitleSection;
